
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import DateInput from "@/components/wmc/DateInput.vue";
import { parse } from "date-fns";

const Pedido = namespace("Pedido");

@Component({
  name: "FiltroFinanceiroContainer",
  components: {
    DateInput,
  },
})
export default class FiltroFinanceiroContainer extends Vue {
  get getBaseDtini() {
    const dt = new Date(Date.now());
    dt.setUTCMonth(dt.getUTCMonth() - 1);
    return dt;
  }

  private tableStatusText = "";
  private search = "";

  private dtIni = this.getBaseDtini;
  private dtFim = new Date(Date.now());
  private awaitingSearch = false;
  private textSearchTimer;

  private get getDtIni() {
    return this.dtIni.toISOString();
  }
  private get getDtFim() {
    return this.dtFim.toISOString();
  }

  mounted() {
    const { periodoini, periodofim, search } = this.$router.currentRoute.query;

    this.search = search as string;

    if (periodoini) this.dtIni = new Date(periodoini as string);
    if (periodofim) this.dtFim = new Date(periodofim as string);
  }

  get getColunasSizeFiltro() {
    if (this.$vuetify.breakpoint.smAndDown) {
      return {
        cols: 12,
      };
    }

    return {};
  }

  onDtIniChange(newDt: string) {
    const dt = parse(newDt, "yyyy-MM-dd", new Date());
    this.$router.push({
      query: {
        ...this.$router.currentRoute.query,
        page: "1",
        periodoini: newDt ? dt.toISOString() : undefined,
      },
    });
  }

  onDtFimChange(newDt: string) {
    const dt = parse(newDt, "yyyy-MM-dd", new Date());
    this.$router.push({
      query: {
        ...this.$router.currentRoute.query,
        page: "1",
        periodofim: newDt ? dt.toISOString() : undefined,
      },
    });
  }

  onSearchTextChanged(value: string, oldValue: string) {
    clearTimeout(this.textSearchTimer);
    this.textSearchTimer = setTimeout(() => {
      this.$router.push({
        query: {
          ...this.$router.currentRoute.query,
          page: "1",
          search: this.search || undefined,
        },
      });
    }, 600);
  }
}
